import React from 'react';

function CommonAction({
  editingInput,
  gridIndex,
  pageIndex,
  showDelete,
  deleteItem,
  handleDuplicateItem,
  supplierVisible,
  handleSupplierPermission,
  isStatic,
  handleStaticGrid,
}) {
  return (
    <div className="potemp-action-btns">
      <button aria-label="Edit" type="button" className="btn btn-border ml-auto py-0 px-1" onClick={() => editingInput(gridIndex, pageIndex)}>
        <span className="icon-edit" />
      </button>
      <button aria-label="Copy" type="button" className="btn btn-border py-0 px-1" onClick={() => handleDuplicateItem()}>
        <span className="icon-copy" />
      </button>
      <button
        aria-label="Active/Inactive Supplier"
        type="button"
        className={`btn btn-border py-0 px-1 ${supplierVisible ? 'text-success' : 'text-danger'}`}
        onClick={() => handleSupplierPermission(gridIndex, pageIndex)}
      >
        <span className="icon-active" />
      </button>
      {showDelete && (
        <button aria-label="Delete" type="button" className="btn btn-border py-0 px-1" onClick={() => deleteItem(gridIndex, pageIndex)}>
          <span className="icon-delete" />
        </button>
      )}
      <button
        aria-label="Static"
        type="button"
        className={`btn btn-border py-0 px-1 ${isStatic && 'text-danger'}`}
        onClick={() => handleStaticGrid(gridIndex, pageIndex)}
      >
        <span className="icon-lock" />
      </button>
    </div>
  );
}
export default CommonAction;
